var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#171719"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1064_3779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9644 8C21.3548 8 21.7456 8 22.136 8C22.3708 8.01761 22.6061 8.02788 22.8399 8.05428C25.6551 8.37314 28.1024 9.48963 30.1584 11.4443C31.7668 12.9736 32.8713 14.8119 33.5038 16.9383C33.788 17.8934 33.9489 18.8671 33.9998 19.8608V21.0321C33.9905 21.1206 33.9768 21.2091 33.9719 21.2976C33.8496 23.5639 33.1164 25.6267 31.8577 27.5007C30.6554 29.2916 29.0768 30.6697 27.1485 31.6458C24.7726 32.8484 22.2617 33.2416 19.6378 32.8596C17.5896 32.5618 15.7274 31.7769 14.0613 30.544C12.2626 29.2128 10.9179 27.5158 10.0285 25.4643C9.24001 23.6436 8.90786 21.7436 9.02135 19.7557C9.08934 18.5658 9.32414 17.4171 9.72135 16.303C10.4189 14.3449 11.5347 12.6557 13.0771 11.2561C14.8625 9.63537 16.9508 8.62549 19.3174 8.17801C19.8628 8.07482 20.4146 8.04988 20.9644 8Z",
    fill: "#858B9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.021 26.6357C15.6116 26.6435 15.2692 26.2049 15.39 25.8141C15.4326 25.6757 15.5064 25.5461 15.572 25.4155C16.5919 23.3904 17.6128 21.3653 18.6337 19.3406C18.802 19.0066 18.9722 18.6741 19.139 18.3395C19.1845 18.2481 19.2481 18.1821 19.3396 18.1361C20.9377 17.3331 22.5353 16.5296 24.1325 15.7246C24.9093 15.3334 25.6841 14.9392 26.4604 14.5465C26.6199 14.4658 26.7735 14.3685 26.9579 14.3563C27.4074 14.3264 27.7645 14.8184 27.5884 15.2449C27.471 15.5295 27.3199 15.8009 27.181 16.0762C26.0789 18.2603 24.9763 20.4444 23.8752 22.629C23.8257 22.7268 23.7641 22.804 23.6638 22.8544C22.0584 23.6604 20.4534 24.4678 18.8489 25.2762C18.0795 25.664 17.312 26.0547 16.543 26.444C16.3767 26.5281 16.2152 26.6269 16.021 26.6357ZM22.5764 20.4962C22.5764 19.8575 22.1454 19.4233 21.5085 19.4208C20.8672 19.4184 20.4319 19.8458 20.427 20.4821C20.4221 21.1335 20.8575 21.5717 21.5071 21.5697C22.1445 21.5677 22.5764 21.1344 22.5764 20.4962Z",
    fill: "#171719"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_3779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExplore);
export default __webpack_public_path__ + "static/media/icon-explore.2ecbc7ae37c98c68fbf1c4c46ab68f81.svg";
export { ForwardRef as ReactComponent };